import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import type { WithTestId } from 'types/app';

import { selectOfferCard } from '@Modules/offers/selectors';

import { Button } from '@Atomic/atoms/Button';

import { ComplaintModal } from '../ComplaintModal';

export const Complaint = ({ testId }: WithTestId) => {
  const [visible, setVisible] = useState(false);
  const { t } = useTranslation();
  const offerCard = useSelector(selectOfferCard);
  const offerId = offerCard?.card?.id;

  if (!offerId) {
    return null;
  }

  return (
    <>
      <Button variant="link" fullWidth onClick={() => setVisible(true)} testId={testId}>
        {t('buttons.complaint')}
      </Button>

      <ComplaintModal
        target={{ offerId: String(offerId) }}
        setVisible={setVisible}
        visible={visible}
        testId={testId}
      />
    </>
  );
};
